export default "__VITE_ASSET__QvdVfaGW__"